import React, { FC } from 'react';
import { useDispatch } from 'react-redux';
import { selectAnswer } from '../store/QuizSlice';
import QuestionCard from './QuestionCard';
import { Question } from '../models/Question';
import { RootDispatch } from '../store/Store';
import { Quiz } from '../models/Quiz';
import { Link } from 'react-router-dom';
import './QuizTemplate.css';


interface QuizTemplateProps { data: Quiz | null }

const QuizTemplate: FC<QuizTemplateProps> = ({data}) => {
  const dispatch = useDispatch<RootDispatch>();

  const handleAnswerClick = (questionIndex: number, selectedOptionId: number) => {
    dispatch(selectAnswer({questionIndex, selectedOptionId}));
  };

  return (
    <div className="quiz-template-container">
      {data && (
        <>
          <div className="quiz-template-header">
            <h1 className="quiz-template-title">{data.title}</h1>
          </div>
          <div className="quiz-questions-container">
            {data.questions.length > 0 && data.questions.map((question: Question, index: number) => (
              <QuestionCard
                key={index}
                index={index}
                data={question}
                handleAnswerClick={handleAnswerClick}
              />
            ))}
          </div>
          <div className="quiz-submit-container">
            <Link to="/projects/vejen-til-dansk-statsborgerskab/resulter" className="quiz-submit-button">
              Submit →
            </Link>
          </div>
        </>
      )}
    </div>
  );
};

export default QuizTemplate;
